import ShadowContainerHorizontal from '@atoms/ShadowContainerHorizontal/ShadowContainerHorizontal';
import Tag from '@atoms/Tag/Tag';
import { ILink } from '@models/ILink';
import SizeEnum from '@models/enums/SizeEnum';
import TagTypesEnum from '@models/enums/TagTypesEnum';
import { useEffect, useState } from 'react';

interface Props {
  readonly links: ILink[];
  readonly title: string;
}

const ProductHero = ({ title, links }: Props) => {
  const [currentUrl, setCurrentUrl] = useState<string>();
  const [currentPath, setCurrentPath] = useState<string>();

  useEffect(() => {
    setCurrentUrl(window.location.href);
    setCurrentPath(window.location.pathname);
  }, []);

  return (
    <section className="bg-black-100 text-white dark:bg-grey-600">
      <div
        className="flex flex-col gap-5 py-7.5 md:container lg:grid lg:grid-cols-12 lg:py-[4.375rem]"
        data-testid="CT-04F-Product-Hero"
      >
        {title && (
          <h1
            className="px-5 md:px-0 lg:col-span-5"
            data-testid="CT-04F-Product-Hero-Title"
          >
            {title}
          </h1>
        )}
        {!!links.length && (
          <div className="flex select-none items-center justify-start lg:col-span-6 lg:col-start-7 lg:justify-end">
            <ShadowContainerHorizontal
              className="flex w-full justify-end"
              shadowColour="dark:from-grey-600 from-black-100"
              threshold={0.01}
              hasTabbableNestedItems
            >
              <div className="flex gap-x-4 px-5 md:px-1">
                {links
                  .filter((link) => link.name && link.url)
                  .map((link, index) => {
                    const tabActive =
                      currentUrl === link.url || currentPath === link.url;
                    return (
                      <Tag
                        className="shrink-0 whitespace-nowrap"
                        key={link.name}
                        link={link}
                        pointerStates={!tabActive}
                        size={SizeEnum.Large}
                        text={`${link.name}`}
                        tagType={
                          tabActive
                            ? TagTypesEnum.Secondary
                            : TagTypesEnum.Three
                        }
                        dataTestId={`CT-04F-Product-Hero-Tag-${index}`}
                      />
                    );
                  })}
              </div>
            </ShadowContainerHorizontal>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductHero;
